import { useMemo } from 'react';

import { useWebEDIStore } from 'stores/webedi/webedi';
import { datachecksResolver } from 'support/helpers/resolvers/datachecksResolver';
import { buildDocumentValidationKey } from 'support/helpers/resolvers/documentValidationKey';
import { DocumentType, RelationshipV2 } from 'support/types/dtos';

import { useProcessSpecification } from './useProcessSpecification';

export const useCreateDocumentSetup = ({
  relationship,
  sourceMessageId,
  documentType,
}: {
  relationship: RelationshipV2 | undefined;
  sourceMessageId?: string;
  documentType: DocumentType | undefined;
}) => {
  const receiverProcessSpecification = useProcessSpecification({
    relationshipId: relationship?.id,
    sourceMessageId,
  });
  const dataStores = useWebEDIStore((state) => state.dataStores);

  const resolver = useMemo(
    () =>
      datachecksResolver({
        fieldsConfiguration: receiverProcessSpecification?.fields,
        withTimeout: true,
        dataStores,
        documentKey: buildDocumentValidationKey({ relationshipId: relationship?.id, sourceMessageId }),
      }),
    [receiverProcessSpecification?.fields, dataStores, relationship?.id, sourceMessageId],
  );

  const isLoading = !relationship || !documentType;

  return {
    resolver,
    isLoadingSetup: isLoading,
    receiverProcessSpecification,
  };
};
